import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "onduty-svg-rec",
  "use": "onduty-svg-rec-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"onduty-svg-rec\"><path d=\"M509.44 515.072m-447.488 0a447.488 447.488 0 1 0 894.976 0 447.488 447.488 0 1 0-894.976 0Z\" fill=\"#ffffff\" /><path d=\"M504.832 524.288m-334.336 0a334.336 334.336 0 1 0 668.672 0 334.336 334.336 0 1 0-668.672 0Z\" fill=\"#ED3232\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol